<p-table
  [columns]="config.columns"
  [value]="config.rows || []"
  [dataKey]="config.dataKey ?? 'id'"
  [tableStyle]="{ 'min-width': '50rem' }"
  [paginator]="pagination"
  paginatorPosition="both"
  [totalRecords]="totalRecordsLazy || 1000"
  [rowsPerPageOptions]="[15, 25, 100]"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {{ lazy ? first + rowsPerPage : '{last}' }} av {{
    lazy && totalRecordsLazy ? totalRecordsLazy : lazy ? 'Beräknar' : '{totalRecords}'
  }}"
  [rowExpandMode]="config.expandMode || 'multiple'"
  [globalFilterFields]="columnFields"
  [tableStyle]="{ 'width.%': 100 }"
  [expandedRowKeys]="expandedRows"
  [rows]="rowsPerPage"
  [first]="first"
  [sortMode]="'multiple'"
  [multiSortMeta]="config.multiSortMeta || undefined"
  [lazy]="lazy"
  (onLazyLoad)="onSortFunction($event)"
  (rowsChange)="updateRowsPerPage($event)"
  [customSort]="!lazy"
  (sortFunction)="customSortFunction($event)"
>
  <ng-template pTemplate="header" let-columns>
    <ng-container *ngTemplateOutlet="dateHeaderTemplate"> </ng-container>
    <tr>
      <ng-container *ngFor="let col of columns">
        <th
          [ngClass]="nameCols.includes(col.field) ? 'name-col' : 'non-name-col'"
          class="{{ col.headerClasses?.join(' ') }}"
          *ngIf="!col.hide"
          [pSortableColumnDisabled]="!col.sortByField"
          [pSortableColumn]="col.sortByField"
        >
          <div (click)="collapseAll()" *ngIf="col.field === 'toggler'">
            <i class="fa-solid fa-angles-up ms-3"></i>
          </div>
          <ng-container *ngIf="col.field !== 'toggler'">{{ col.header }}</ng-container>
          <p-sortIcon [field]="col.field" *ngIf="col.sortByField"></p-sortIcon>
        </th>
      </ng-container>
    </tr>
    <tr *ngIf="hasFilters()">
      <ng-container *ngFor="let col of columns">
        <th *ngIf="col.columnFilter === 'multi-select' && !col.hide">
          <p-columnFilter
            [field]="col.field"
            matchMode="in"
            [showMenu]="false"
            [showOperator]="false"
            [showAddButton]="false"
          >
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-multiSelect
                [ngModel]="value"
                [options]="col.filterOptions || SMEs"
                placeholder=""
                (onChange)="filter($event.value)"
                optionValue="name"
                optionLabel="label"
                [showHeader]="false"
                [showToggleAll]="false"
                [showMenu]="false"
                [showClear]="false"
                [appendTo]="'body'"
                panelStyleClass="app-table-multiselect-panel"
              >
                <ng-template let-option pTemplate="item">
                  <div>
                    <span>{{ option.label }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </th>
        <th *ngIf="col.columnFilter === 'text' && !col.hide">
          <p-columnFilter
            [field]="col.field"
            matchMode="contains"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false"
            [showButtons]="false"
            [showMenu]="false"
          >
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input type="text" pInputText [ngModel]="value" (ngModelChange)="filter($event)" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th *ngIf="!col.columnFilter && !col.hide"></th>
      </ng-container>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-columns="columns" let-expanded="expanded">
    @if (loading) {
      <ng-container [ngTemplateOutlet]="loadingRow" />
    } @else {
      <tr
        [ngClass]="{ 'row-expanded': expanded }"
        (click)="columns[0].click && columns[0].click(row)"
        [pRowTogglerDisabled]="!columns[0].isRowToggler"
        [pRowToggler]="row"
      >
        <ng-container *ngFor="let col of columns">
          <!-- TOGGLE DETAILS VIEW FOR THIS ROW-->
          <td *ngIf="col?.isRowToggler; else cellBlock">
            <p-button id="table-btn-expand" [link]="true" [icon]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'">
            </p-button>
          </td>
          <!-- REGULAR CELL CONTENT -->
          <ng-template #cellBlock>
            <td
              [ngClass]="nameCols.includes(col.field) ? 'name-col' : 'non-name-col'"
              class="{{ col.headerClasses?.join(' ') }}"
              [ngSwitch]="col.type"
              *ngIf="!col.hide"
            >
              <ng-container *ngSwitchCase="'badge'">
                <span class="mas-badge {{ col.classes?.join(' ') }} ">
                  {{ col.mapView ? col.mapView(row) : row[col.field] }}</span
                >
              </ng-container>
              <ng-container *ngSwitchCase="'array'">
                <span>{{ row[col.field]?.length > 1 ? row[col.field][0] + "..." : row[col.field] }}</span>
              </ng-container>
              <div *ngSwitchCase="'iconAndBadge'" class="icon-badge-wrapper">
                <div *ngFor="let icon of row[col.field]; let index = index">
                  <ng-container *ngIf="icon">
                    <div>
                      <i
                        class="mas-icon"
                        [ngClass]="icon.icon"
                        [title]="icon.customTitle"
                        *ngIf="icon.displayIcon"
                        (click)="col.iconItems[index].click ? col.iconItems[index].click(row) : null"
                      ></i
                      ><span class="mas-badge" *ngIf="row[col.field].value">{{ row[col.field].value }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngSwitchCase="'icon'">
                <div class="icon">
                  <i
                    [ngClass]="col.icon"
                    *ngIf="row[col.field] != null && row[col.field] !== '' && row[col.field]?.length > 0"
                    [title]="getComment(row, col)"
                  ></i>
                  <!--[title]="row[col.field]?.length ? row[col.field][0].kommentar : row[col.field]" -->
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'date'">
                {{
                  col.useAlternative && col.useAlternative(row)
                    ? col.alternative(row)
                    : (row[col.field] | date: "yyyy-MM-dd")
                }}
              </ng-container>
              <ng-container *ngSwitchCase="'editButton'">
                @if (col.editableCondition) {
                  @if (
                    (col.editableCondition.value === null &&
                      row[col.editableCondition.field] !== col.editableCondition.value) ||
                    (col.editableCondition.value !== null &&
                      row[col.editableCondition.field] === col.editableCondition.value)
                  ) {
                    <p-button label="Ändra" icon="fas fa-pen" [link]="true" (click)="col.click(row)"></p-button>
                  }
                } @else {
                  <p-button label="Ändra" icon="fas fa-pen" [link]="true" (click)="col.click(row)"></p-button>
                }
              </ng-container>
              <ng-container *ngSwitchCase="'dropdown'">
                <p-select
                  id="smittamneType"
                  (onChange)="col.click(row)"
                  styleClass="w-100"
                  [(ngModel)]="row[col.field]"
                  [options]="col.dropdownOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="-"
                >
                </p-select>
              </ng-container>
              <ng-container *ngSwitchCase="'editable'">
                @if (row[col.editableCondition.field] === col.editableCondition.value) {
                  <td [pEditableColumn]="row" [pEditableColumnField]="col">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input
                          pInputText
                          type="text"
                          [(ngModel)]="row[col.field]"
                          (ngModelChange)="col.cellChange(row)"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ col.useAlternative && col.useAlternative(row) ? col.alternative(row) : row[col.field] }}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                } @else {
                  {{ col.useAlternative && col.useAlternative(row) ? col.alternative(row) : row[col.field] }}
                }
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div>
                  {{ col.mapView ? col.mapView(row[col.field]) : row[col.field] }}
                </div>
                <!-- {{ col.useAlternative && col.useAlternative(row) ? col.alternative(row) : row[col.field] }} -->
              </ng-container>
            </td>
          </ng-template>
        </ng-container>
      </tr>
    }
  </ng-template>
  <!-- DETAILS VIEW FOR A ROW WITH A ROW TOGGLER -->
  <ng-template pTemplate="expandedrow" let-row>
    <tr class="mas-table rowexpansion">
      <td [attr.colspan]="config.columns?.length" style="padding: 0">
        <ng-content select="[detailsView]"></ng-content>
        @if (config.accordionContent === "atgards-lista") {
          <app-atgards-details [row]="row" [rows]="config.rows"></app-atgards-details>
        }
        @if (config.accordionContent === "larm-details") {
          <app-larm-details [row]="row" [showBy]="config.columns![1].header"></app-larm-details>
        }
        @if (config.accordionContent === "larm-kriterium-details") {
          <app-larm-kriterium-details [kriterium]="row"></app-larm-kriterium-details>
        }
        @if (config.accordionContent === "inskicksresultat") {
          <app-inskicks-resultat-details [resultat]="row"></app-inskicks-resultat-details>
        }
      </td>
    </tr>
  </ng-template>

  <ng-template #loadingRow>
    <tr *ngFor="let i of [].constructor(config.columns?.length)">
      <td *ngFor="let j of [].constructor(config.columns?.length)"><p-skeleton /></td>
    </tr>
  </ng-template>
</p-table>
